export const isEqualValue = (a, b) => {
  return JSON.stringify(a ?? null) === JSON.stringify(b ?? null);
};
